module.exports = __webpack_public_path__ + "img/phone-active.9712f4d8.svg";